import { render } from "./UserRoles.vue?vue&type=template&id=1ca15e04"
import script from "./UserRoles.vue?vue&type=script&lang=js"
export * from "./UserRoles.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/admin/UserRoles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ca15e04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ca15e04', __exports__)) {
    api.reload('1ca15e04', __exports__)
  }
  
  module.hot.accept("./UserRoles.vue?vue&type=template&id=1ca15e04", () => {
    api.rerender('1ca15e04', render)
  })

}


export default __exports__